import { render, staticRenderFns } from "./CAxAFAxFamiliarPt1Page.vue?vue&type=template&id=418f56ff"
import script from "./CAxAFAxFamiliarPt1Page.vue?vue&type=script&lang=js"
export * from "./CAxAFAxFamiliarPt1Page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports